/** @file A plan's commands counted by name, most frequent first (the review's command summary). */
import type { AutorigPlan } from '@pose2d/autorig/types';

/** Ties sort by command name. */
export function planSummary(plan: AutorigPlan): { name: string; count: number }[] {
  const counts = new Map<string, number>();
  for (const call of plan.commands) counts.set(call.name, (counts.get(call.name) ?? 0) + 1);
  return [...counts]
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count || (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
}
